"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PanelInputWithInfo = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _row = _interopRequireDefault(require("../row"));

var _col = _interopRequireDefault(require("../col"));

require("./index.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Node
// ShpmtcDesign Components
// Style
var PanelInputWithInfo = function PanelInputWithInfo(_ref) {
  var divideLine = _ref.divideLine,
      rowAlign = _ref.rowAlign,
      leftBlocClass = _ref.leftBlocClass,
      bottomBlocClass = _ref.bottomBlocClass,
      leftBloc = _ref.leftBloc,
      leftBlocCol = _ref.leftBlocCol,
      rightBloc = _ref.rightBloc,
      rightBlocAddon = _ref.rightBlocAddon,
      bottomBloc = _ref.bottomBloc;

  var getRightBlocAddon = function getRightBlocAddon() {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "panel-inputWithInfo__right-addon"
    }, rightBlocAddon);
  };

  var getBottomBloc = function getBottomBloc() {
    return /*#__PURE__*/_react.default.createElement(_row.default, {
      gutter: 20,
      align: "top"
    }, /*#__PURE__*/_react.default.createElement(_col.default, {
      span: 24
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "panel-inputWithInfo__bottom ".concat(bottomBlocClass, " ")
    }, bottomBloc)));
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "panel-inputWithInfo"
  }, /*#__PURE__*/_react.default.createElement(_row.default, {
    gutter: 20,
    type: "flex",
    justify: "space-around",
    align: rowAlign || 'top'
  }, /*#__PURE__*/_react.default.createElement(_col.default, {
    xs: 24,
    sm: leftBlocCol === 0 ? 0 : 24,
    md: leftBlocCol
  }, /*#__PURE__*/_react.default.createElement("section", {
    className: "panel-inputWithInfo__left\n            ".concat(leftBlocClass, " ").concat(divideLine === 'left' ? 'divide-line divide-line--right' : '', "\n            ").concat(leftBlocCol === 0 ? 'divide-line--none' : '', "\n            ").concat(rightBlocAddon ? 'has-addon' : '')
  }, leftBloc, rightBlocAddon ? getRightBlocAddon() : null)), /*#__PURE__*/_react.default.createElement(_col.default, {
    xs: 24,
    sm: 24,
    md: 24 - leftBlocCol
  }, /*#__PURE__*/_react.default.createElement("section", {
    className: "panel-inputWithInfo__right\n              ".concat(divideLine === 'right' ? 'divide-line divide-line--left' : '', "\n              ").concat(leftBlocCol === 0 ? 'divide-line--none' : '', "\n              ").concat(rightBlocAddon ? 'has-addon' : '', "\n            ")
  }, rightBloc))), rightBlocAddon ? getRightBlocAddon() : null, bottomBloc ? getBottomBloc() : null);
}; // Prop Types


exports.PanelInputWithInfo = PanelInputWithInfo;
PanelInputWithInfo.defaultProps = {
  divideLine: 'left',
  rowAlign: 'top',
  leftBlocClass: '',
  leftBlocCol: 8,
  rightBlocAddon: null,
  bottomBloc: null,
  bottomBlocClass: ''
};
PanelInputWithInfo.propTypes = {
  divideLine: _propTypes.default.string,
  rowAlign: _propTypes.default.string,
  leftBlocClass: _propTypes.default.string,
  bottomBlocClass: _propTypes.default.string,
  leftBloc: _propTypes.default.node.isRequired,
  leftBlocCol: _propTypes.default.number,
  rightBloc: _propTypes.default.node.isRequired,
  rightBlocAddon: _propTypes.default.node,
  bottomBloc: _propTypes.default.node
};